import { format, parseJSON, isToday } from 'date-fns';

export const parseJSONRawDate = rawDate => parseJSON(rawDate);

export const formatDate = (date, stringFormat) => format(date, stringFormat);

export const ifToday = date => isToday(date);
